import knifeMakerDefaultState from '~src/store/preloaded-state'
import { App } from '~src/types/types-store'

import {
  SettingsActionName,
  SettingsActionTypes,
} from '~src/types/actions/settings-actions'

const appReducer = (
  state = knifeMakerDefaultState.app,
  action: SettingsActionTypes
): App => {
  if (action.type === SettingsActionName.SET_LANGUAGE) {
    return {
      ...state,
      language: action.lang,
    }
  }
  return state
}

// eslint-disable-next-line import/prefer-default-export
export { appReducer }
